import { Controller } from 'stimulus'

/**
 * 内容物に応じて大きさが変わる Textarea
 */
export default class extends Controller {
  static get targets() {
    return ['dummy']
  }

  update(e) {
    this.dummyTarget.textContent = e.target.value + '\u200b'
  }
}
